export default "__VITE_ASSET__671f3b4e__"